import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Terminal, UltimaLectura } from './../../../_entities/terminal/terminal';
import { environment } from './../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class TerminalService {

	constructor(private http: HttpClient) { }

	getTerminales(): Observable<Terminal[]> {
		return this.http.get<Terminal[]>(`${environment.API_SECURITY}/api/HandheldUHF`);
	}

	getHistoricRecords(id: string, fechaInicio: string, fechaFin: string): Observable<UltimaLectura[]> {
		return this.http.get<UltimaLectura[]>(`${environment.API_SECURITY}/api/HandheldUHF/Historico`, {
			params: {
				id,
				fechaInicio,
				fechaFin
			}
		});
	}

}
